import React, { lazy, Suspense, memo } from "react";
import { useSelector } from "react-redux";
import Loading from "components/shared-components/Loading";
import Views from "views";
import { useLocation } from "react-router-dom";
import { PUBLICROUTES } from "routes/PublicRoute";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);
  const { pathname } = useLocation();
  const Layout =
    token && !blankLayout && !PUBLICROUTES.includes(pathname)
      ? AppLayout
      : AuthLayout;
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Layout>
        <Views />
      </Layout>
    </Suspense>
  );
};

export default memo(Layouts);
